import { collection, getDocs, query, where } from 'firebase/firestore'
import { firebaseAuth, firestoreDb } from './firebase'
import { createChecklistNative } from './checklistWriter'
import { scopedReadConstraints } from './accessScopeService'

export const createAnalysisAlertChecklist = async ({ workspaceId, title, assigneeUid, sourceRuleId, sourceRowAnchor }: { workspaceId: string; title: string; assigneeUid: string; sourceRuleId?: string; sourceRowAnchor?: string }) => {
  const actor = firebaseAuth.currentUser
  if (!actor) throw new Error('Sign in to create an analysis alert task.')
  return createChecklistNative({ workspaceId, parentContainerId: 'workspace-default-checklist', title, checklistType: 'INDIVIDUAL', extra: { assigneeId: assigneeUid, source: sourceRuleId ? 'analysis-alert' : 'analysis-row-convert', ...(sourceRuleId ? { sourceRuleId } : {}), ...(sourceRowAnchor ? { sourceRowAnchor } : {}) } }, { uid: actor.uid, displayName: actor.displayName })
}

export const listAnalysisAlertChecklists = async ({ workspaceId }: { workspaceId: string }) =>
  getDocs(
    query(
      collection(firestoreDb, 'checklists'),
      where('workspaceId', '==', workspaceId),
      where('source', '==', 'analysis-alert'),
      ...scopedReadConstraints(workspaceId),
    ),
  )
